<template>
  <div>
    <div class="side-background" :style="`background-image: url('/static/images/logo/bg-image-${$adnetworkTheme}.jpg')`">
      <div class="side-background-foreground">
        <div class="container-fluid p-0">
        <div class="row">
          <div class="col-12 p-0">
            <div class="login-card">
              <div class="theme-form login-form">
                <div class="logo-wrapper d-flex justify-content-center"><img class="img-fluid" :src="`/static/images/logo/logo-${$adnetworkTheme}.png`" alt=""></div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">

                  <div class="top-right" v-on="on">
                      <v-select
                        class="languagepicker"
                        :menu-props="{minWidth: '180'}"
                        v-model="selectedlanguage"
                        :items="possiblelanguages"
                        append-icon=""
                        item-text="name"
                        item-value="shortForm"
                        hide-details
                        @input="setLanguage(selectedlanguage)"
                      >
                        <template slot="item" slot-scope="data">
                          <img style="width:26px;height:17px;vertical-align: unset;" :src="'/files/flags/' + data.item.flag"> &nbsp; {{data.item.name}}
                        </template>
                        <template slot='selection' slot-scope='{item}'>
                          <img style="width:26px;height:17px;vertical-align: unset;" :src="'/files/flags/' + item.flag">
                        </template>
                      </v-select>
                </div>
                  </template>
                  <span>{{$t('change_language')}}</span>
                </v-tooltip>
                <div class="form-group">
                  <label>{{$t("email")}}</label>
                  <input class="form-control" type="email" required="" v-model="credentials.mail" @keypress.enter="login()" placeholder="Test@gmail.com">
                </div>
                <div class="form-group">
                  <label>{{$t("password")}}</label>
                  <input class="form-control" type="password" v-model="credentials.password" @keypress.enter="login()" required="" placeholder="*********">
                </div>
                <div class="form-group">
                  <a class="link float-left" @click="$router.push('/register')">{{$t("no_account_register")}}</a>
                  <button class="btn btn-primary-light btn-block" @click="login()"><a href="javascript:void(0)">{{$t("login")}}</a></button>
                  <a class="link" @click="$router.push('/forgot-password')">{{$t("forgot_password")}}</a>
                </div>
                <!-- <p>Don't have account?<a class="ms-2" href="log-in.html">Create Account</a></p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    routingTarget: String,
  },


  data() {
    return {
      showPassword: false,

      selectedlanguage:null,
      possiblelanguages: [],

      credentials: {
        mail: "",
        password: ""
      },
    };
  },

  mounted() {
    showLoadingCircle(false);
    this.$axios.checkBearer().then(this.onLoggedIn).catch(this.discardError);
    this.getCurrentLanguage();
    this.getLanguages();
  },

  methods: {
    login() {
      this.$axios.credentials = this.credentials;
      this.$axios.authorize().then(this.onLoggedIn).catch(this.onLoginFailed);
    },
    onLoggedIn(response) {
      this.$axios
        .get("/api/user/me")
        .then(this.onSuccessfulLogin)
        .catch(this.onLoginFailed);
    },
    onSuccessfulLogin(response){
      this.user = response.data;
      Vue.prototype.$user = response.data;
      Vue.prototype.$rights = response.data.allRights;
      
      if(this.routingTarget != null){
        this.$router.push(this.routingTarget);
        window.location.reload();
        return;
      }

      if(this.$rights.includes("VIEW_DASHBOARD")){
        this.$router.push("dashboard");
      }else{
        this.$router.push("cases");
      }

      if(this.$reloadAppBudget != null){
        this.$reloadAppBudget();
      }
      if(this.$reloadAppCurrentUser != null){
        this.$reloadAppCurrentUser();
      }
      if(this.$reloadActiveAds != null){
        this.$reloadActiveAds();
      }
      
      this.$forceUpdate();
    },
    onLoginFailed(error) {
      if(error.toString().toLowerCase().includes("code 425")){
        this.$noty.error(this.$t("ERROR_UNVERIFIED_EMAIL"));
      }else{
        this.$noty.error(this.$t("ERROR_INVALID_CREDENTIALS"));
      }
      showLoadingCircle(false);
    },
    logError(error) {
      console.log(error);
    },
    getCurrentLanguage(){
      var _this = this;
      this.$axios
        .get("/api/language/me")
        .then(function(response){
          _this.selectedlanguage = response.data.shortForm;
        })
        .catch(this.logError);
    },
    getLanguages() {
      progressIndicator.hidden = false;
      var _this = this;
      this.$axios
        .get("/api/language/all")
        .then(function(response){
          _this.languages = response.data;
          _this.convertLanguages(_this.languages);
          
          // Make function accessible for getting flag by language
          Vue.prototype.$languages = _this.languages;
        })
        .catch(this.logError);
    },
    convertLanguages(languages){
      const lnlist = [];
      for (var i in languages){
        var language = {};
        var ln = languages[i].language;
        
        // console.log(this.$t(languages[i].language));
        language.name = this.$t(languages[i].language);
        language.flag = languages[i].flag;
        language.shortForm = languages[i].shortForm;
        lnlist.push(language);
        
      }
      this.possiblelanguages = lnlist;
    },

    setLanguage(shortForm){
      if(!window.location.href.includes('?')){
        window.location.href = window.location.href + "?lang=" + shortForm; 
      }else{
        window.location.href = window.location.href + "&lang=" + shortForm;
      }
    },
    checkIfFromMailVerification(){
      var token = url.searchParams.get("verified");
      if(!token) return;
      this.$noty.success(this.$t("email_verified"));
    },
    discardError(error) {
      showLoadingCircle(false);
    }
  },
};
</script>

<style>
</style>